import React, {Fragment} from 'react'
import ChatPrompt from './ChatPrompt'
import ChatResponse from './ChatResponse'
import ChatResponseStream from './ChatResponseStream'
import PropTypes from "prop-types";

ChatItem.propTypes = {
  chat: PropTypes.object.isRequired,
  chatIndex: PropTypes.number.isRequired,
  primary: PropTypes.bool,
  hidePrompt: PropTypes.bool,
};

export default function ChatItem(props) {
  const [collapsed, setCollapsed] = React.useState(false);
  const toggleCollapsed = React.useCallback(() => {
    setCollapsed(!collapsed);
  }, [collapsed]);

  return <Fragment>
    {!props.hidePrompt &&
      <ChatPrompt
        chat={props.chat}
        onClick={toggleCollapsed}
        collapsed={collapsed}
      />}
    {!collapsed && !props.stream &&
      <ChatResponse
        chat={props.chat}
        chatIndex={props.chatIndex}
      />}
    {!collapsed && props.stream &&
      <ChatResponseStream
        stream={props.stream}
      />}
  </Fragment>
}
